import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { ChatIcon, CloseIcon } from "@chakra-ui/icons";

const ChatBotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jotfor.ms/agent/embedjs/0198a8008f707b16a5530578d1b78a9e6eda/embed.js";
      script.async = true;
      script.id = "jotform-script"; // give it an id so we can remove later
      document.body.appendChild(script);

      return () => {
        const existing = document.getElementById("jotform-script");
        if (existing) existing.remove();
      };
    }
  }, [isOpen]);

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
        <IconButton
          icon={<ChatIcon />}
          aria-label="Open chat"
          colorScheme="blue"
          borderRadius="full"
          size="lg"
          boxShadow="lg"
          position="fixed"
          bottom="20px"
          right="20px"
          zIndex={9999}
          onClick={() => setIsOpen(true)}
        />
      )}

      {/* Custom Chat Window */}
      {isOpen && (
        <Box
          position="fixed"
          bottom="20px"
          right="20px"
          w={{ base: "90%", sm: "320px" }}
          h="400px"
          bg="white"
          borderRadius="md"
          boxShadow="xl"
          display="flex"
          flexDirection="column"
          zIndex={9999}
        >
          <Flex
            bg="blue.500"
            color="white"
            p={3}
            justify="space-between"
            align="center"
          >
            <Text fontWeight="bold">Chat Support</Text>
            <IconButton
              icon={<CloseIcon />}
              aria-label="Close chat"
              size="sm"
              variant="ghost"
              color="white"
              onClick={() => setIsOpen(false)}
            />
          </Flex>

          {/* Jotform will render inside this box after script loads */}
          <Box flex="1" id="jotform-chat-container" />
        </Box>
      )}
    </>
  );
};

export default ChatBotWidget;
